import { AbstractParser } from "../../parser";
import { Injectable } from "@angular/core";
import { ImportIndustryProductsDiscountsResult } from "src/app/ui/models/domains/pbm/industry/import-industry-products-discounts-result.model";

@Injectable()
export class ImportIndustryProductDiscountParser extends AbstractParser<ImportIndustryProductsDiscountsResult> {
  parse(payload: any): ImportIndustryProductsDiscountsResult {
    const message = new ImportIndustryProductsDiscountsResult();
    if (payload.error) {
      message.setMessageResult(payload.error.Data.ErrorMessage);
    } else if (payload[0].Message) {
      message.setMessageResult(payload[0].Message);
    }
    return message;
  }
}
